import styled from "styled-components";
import { colors } from "../../utils/styled/_variables.styled";
import { buttonNovoConhecerContainerProps } from "./ButtonCTA.types";

export const Style = styled.div<buttonNovoConhecerContainerProps>`
  background-color: ${(props: { $backgroundcolor: string }) =>
    props.$backgroundcolor};

  display: flex;
  justify-content: center;
  align-items: center;

  .style-button{
    padding: 0 24px;
  }

  .icon-button{
    display:none;

    @media (min-width: 992px) {
      display: ${({ $iconcheck }) => $iconcheck ? "block" : "none"};
    }
  }
  .label-button{
    margin-left: 5px;
    color: #FFFFFF;
    display: block;

    @media (min-width: 992px) {
      display: none;
    }
    @media (min-width: 1200px) {
      display: block;
    }
  }

`;



export const StyledButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 48px;
  padding: 12px 24px;
  border-radius: 8px;
  font-family: "Averta Std", sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  text-align: center;
  cursor: pointer;
  transition: background-color 0.3s ease, color 0.3s ease;
  border: none;

  &.default {
    width: 360px;
    background-color: #079d56;
    color: #fff;
   
  }

  &.defaultFullWidth {
    width: 100%;
    background-color: #079d56;
    color: #fff;
  }

  &.outline {
    width: 360px;
    background-color: #fff;
    color: #079d56;
    border: 1px solid #079d56;
  }

  &.outlineFullWidth {
    width: 100%;
    background-color: #fff;
    color: #079d56;
    border: 1px solid #079d56;
  }

  &.greyVariationFullWidth {
    width: 100%;
    background-color: #f2f2f2;
    color: ${colors.greenDark};
    font-size: 24px;
    font-weight: 700;
    line-height: 36px;
  }

  &:hover:not(:disabled) {
    background-color: ${colors.greenDark};
    color: #fff;
  }

  &:disabled {
    background-color: #d9dddb;
    color: #999e9c;
    cursor: not-allowed;
  }
 
`;

export const StyledAnchor = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 48px;
  padding: 12px 24px;
  border-radius: 8px;
  font-family: "Averta Std", sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  transition: background-color 0.3s ease, color 0.3s ease;

  &.default {
    width: 360px;
    background-color: #079d56;
    color: #fff;
  }

  &.defaultFullWidth {
    width: 100%;
    background-color: #079d56;
    color: #fff;
  }

  &.outline {
    width: 360px;
    background-color: #fff;
    color: #079d56;
    border: 1px solid #079d56;
  }

  &.outlineFullWidth {
    width: 100%;
    background-color: #fff;
    color: #079d56;
    border: 1px solid #079d56;
  }

  &.greyVariationFullWidth {
    width: 100%;
    height: fit-content;
    gap: 16px;
    background-color: #f2f2f2;
    color: ${colors.greenDark};
    font-size: 24px;
    font-weight: 700;
    line-height: 36px;

    & > img {
      width: 40px;
      height: 40px;
    }
  }

  &:hover {
    background-color: ${colors.greenDark};
    color: #fff;
  }

  &.greyVariationFullWidth:hover {
    background-color: #8ee2b3;
    color: ${colors.greenDark};
  }

  &[aria-disabled="true"] {
    background-color: #d9dddb;
    color: #999e9c;
    cursor: not-allowed;
    pointer-events: none;
  }
`;
